import template from './template.rt'
import './styles.css'

export const CaptchaNotice = props => template.call({ props })

export default CaptchaNotice
